import { FC } from 'react'

import { ISvgClass } from '../interface'

const AssignmentLateOutlineRoundedIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12 18C12.2833 18 12.521 17.904 12.713 17.712C12.905 17.52 13.0007 17.2827 13 17C13 16.7167 12.904 16.479 12.712 16.287C12.52 16.095 12.2827 15.9993 12 16C11.7167 16 11.479 16.096 11.287 16.288C11.095 16.48 10.9993 16.7173 11 17C11 17.2833 11.096 17.521 11.288 17.713C11.48 17.905 11.7173 18.0007 12 18ZM12 14C12.2833 14 12.521 13.904 12.713 13.712C12.905 13.52 13.0007 13.2827 13 13V9C13 8.71667 12.904 8.479 12.712 8.287C12.52 8.095 12.2827 7.99933 12 8C11.7167 8 11.479 8.096 11.287 8.288C11.095 8.48 10.9993 8.71733 11 9V13C11 13.2833 11.096 13.521 11.288 13.713C11.48 13.905 11.7173 14.0007 12 14ZM5 22C4.45 22 3.979 21.804 3.587 21.412C3.195 21.02 2.99934 20.5493 3 20V6C3 5.45 3.196 4.979 3.588 4.587C3.98 4.195 4.45067 3.99933 5 4H9.2C9.41667 3.4 9.77934 2.91667 10.288 2.55C10.7967 2.18333 11.3673 2 12 2C12.6333 2 13.2043 2.18333 13.713 2.55C14.2217 2.91667 14.584 3.4 14.8 4H19C19.55 4 20.021 4.196 20.413 4.588C20.805 4.98 21.0007 5.45067 21 6V20C21 20.55 20.804 21.021 20.412 21.413C20.02 21.805 19.5493 22.0007 19 22H5ZM5 20H19V6H5V20ZM12 5.25C12.2167 5.25 12.3957 5.179 12.537 5.037C12.6783 4.895 12.7493 4.716 12.75 4.5C12.75 4.28333 12.679 4.10433 12.537 3.963C12.395 3.82167 12.216 3.75067 12 3.75C11.7833 3.75 11.6043 3.821 11.463 3.963C11.3217 4.105 11.2507 4.284 11.25 4.5C11.25 4.71667 11.321 4.89567 11.463 5.037C11.605 5.17833 11.784 5.24933 12 5.25Z"
        fill="inherit"
      />
    </svg>
  )
}

export default AssignmentLateOutlineRoundedIcon
